import React from "react";
import { useNavigate } from "react-router-dom";
import MyWsgCardBadge from "../Components/MyWsgCardBadge";

export interface IBlogCard {
  id?: string;
  title: string;
  postContent: string;
  dateCreated: string;
  author: string;
  legacyId: string;
  isDeleted: boolean;
  slug: string;
  featured?: boolean;
}

interface IBlogProps {
  data: IBlogCard[];
}

const Blog: React.FC<IBlogProps> = ({ data }) => {
  const navigate = useNavigate();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
    });
  };

  const blogItem = (blog: IBlogCard) => {
    return (
      <button
        className="flex flex-col text-left"
        onClick={() =>
          window.open(
            `https://members-legacy.worldservicesgroup.com/blog/post/${blog.slug}.aspx`,
            "_blank"
          )
        }
      >
        <div className="text-base text-Default hover:text-primary truncate">
          {blog.title}
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-font underline">By {blog.author}</span>
          <div className="w-px bg-primary-light"></div>
          <span className="text-sm text-gray-font">
            {formatDate(blog.dateCreated)}
          </span>
        </div>
      </button>
    );
  };

  return (
    <div className="flex flex-col gap-8 text-gray-font w-full max-w-full overflow-hidden">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col 2">
          <MyWsgCardBadge title="Featured Blog" />

          <button
            className="flex flex-col text-left"
            onClick={() => navigate("/blog/featuredblog.aspx")}
          >
            <div className="text-xl leading-8 text-gray-font font-semibold hover:text-primary mb-2">
              Arendt & Medernach Discusses AI Trends in Banking – Delano
              Magazine
            </div>
            <div
              className="self-stretch text-base leading-6 font-normal overflow-hidden text-gray-font"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                textOverflow: "ellipsis",
                lineHeight: "24px",
              }}
            >
              In this feature article, Marc Mouton and Astrid Wagner, Partners
              at member firm Arendt & Medernach, discuss how generative AI can
              revolutionize banking operations, enhance risk management and
              improve financial performance, while also highlighting the
              evolving regulatory landscape with ethical considerations and data
              protection.
            </div>
            <div className="text-sm text-gray-font flex items-center gap-2">
              <a
                href="/member/law-firm/arendt-and-medernach/250"
                className="italic hover:text-Default"
                onClick={(e) => e.stopPropagation()}
              >
                Arendt & Medernach
              </a>
              <div className="w-px h-4 bg-primary-light"></div>
              <div className="flex items-center gap-1">
                <span className="text-sm text-gray-font">As seen in</span>
                <a
                  href="https://delano.lu/article/compliance-will-need-banks-to-"
                  className="italic hover:text-Default"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  Delano Magazine
                </a>
              </div>
            </div>
          </button>
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex items-center w-full">
            <span className="text-right text-lg md:text-xl mr-2 font-semibold">
              Explore more blogs
            </span>
            <div className="flex-1 border-t border-primary-light"></div>
          </div>
          <div>
            <div className="flex flex-col gap-4 align-start self-stretch">
              {data && data.length > 0 ? (
                data.slice(0, 2).map((blog) => blogItem(blog))
              ) : (
                <div className="text-gray-font text-sm">No blogs available</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
